// resizable.js - reusable directive for resizable table columns
// Usage: Vue.directive('resizable', resizable)

const CSS_ID = 'v-resizable-table-css';

function ensureStyles() {
  if (document.getElementById(CSS_ID)) return;
  const css = `
/* v-resizable directive styles */
.resizable-table { table-layout: auto; }
.resizable-table thead th, .resizable-table tbody td { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.resizable-table thead th { position: relative; }
.vrt-resize-handle { position: absolute; right: 0; top: 0; bottom: 0; width: 8px; cursor: col-resize; z-index: 6; background: transparent; transition: background .12s; }
.vrt-resize-handle:hover { background: rgba(0,123,255,0.12); }
.vrt-resize-handle.dragging { background: rgba(0,123,255,0.25); }
`;
  const style = document.createElement('style');
  style.id = CSS_ID;
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
}

function findTable(el) {
  if (!el) return null;
  if (el.tagName === 'TABLE') return el;
  return el.querySelector('table');
}

function setup(tableEl) {
  if (!tableEl) return;
  ensureStyles();
  tableEl.classList.add('resizable-table');

  // remove existing handles
  tableEl.querySelectorAll('.vrt-resize-handle').forEach(h => h.remove());

  const thead = tableEl.querySelector('thead');
  if (!thead) return;
  const headers = Array.from(thead.querySelectorAll('th'));
  if (!headers.length) return;

  headers.forEach((th, idx) => {
    // create handle
    const existing = th.querySelector('.vrt-resize-handle');
    if (existing) existing.remove();

    th.style.position = th.style.position || 'relative';

    const handle = document.createElement('div');
    handle.className = 'vrt-resize-handle';
    th.appendChild(handle);

    // mousedown start
    const onMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const startX = e.clientX;
      // Use getBoundingClientRect to get accurate width
      const startWidth = Math.round(th.getBoundingClientRect().width);
      const MIN = 50;

      handle.classList.add('dragging');

      const columnIndex = idx + 1; // nth-child is 1-based

      const onMouseMove = (mv) => {
        const delta = mv.clientX - startX;
        const newWidth = Math.max(MIN, Math.round(startWidth + delta));

        // apply widths to header
        th.style.width = newWidth + 'px';
        th.style.minWidth = newWidth + 'px';
        th.style.maxWidth = newWidth + 'px';

        // apply to each body cell
        const rows = Array.from(tableEl.querySelectorAll('tbody tr'));
        rows.forEach(row => {
          const cell = row.querySelector(`td:nth-child(${columnIndex})`);
          if (cell) {
            cell.style.width = newWidth + 'px';
            cell.style.minWidth = newWidth + 'px';
            cell.style.maxWidth = newWidth + 'px';
          }
        });
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        handle.classList.remove('dragging');
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    };

    handle.addEventListener('mousedown', onMouseDown);

    // store reference so we can cleanup later
    handle.__vrt_onmousedown = onMouseDown;
  });
}

function destroy(tableEl) {
  if (!tableEl) return;
  tableEl.classList.remove('resizable-table');
  tableEl.querySelectorAll('.vrt-resize-handle').forEach(h => {
    if (h.__vrt_onmousedown) h.removeEventListener('mousedown', h.__vrt_onmousedown);
    h.remove();
  });
}

export default {
  inserted(el) {
    // Find real table element inside b-table wrapper
    const table = findTable(el);
    // Defer so b-table finishes render
    setTimeout(() => setup(table), 50);
  },
  componentUpdated(el) {
    const table = findTable(el);
    setTimeout(() => setup(table), 50);
  },
  unbind(el) {
    const table = findTable(el);
    destroy(table);
  }
};
